var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 3.75H14V1.25C14 0.559687 13.4403 0 12.75 0H5.25C4.55969 0 4 0.559687 4 1.25V3.75H2.125C1.43469 3.75 0.875 4.30969 0.875 5V6.25H17.125V5C17.125 4.30969 16.5653 3.75 15.875 3.75ZM6.5 3.75V2.5H11.5V3.75H6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 18.7502C2.125 19.4405 2.68453 20 3.37484 20H14.6253C15.3155 20 15.875 19.4405 15.875 18.7503V18.7502V7.5H2.125V18.7502ZM11.5 10.625C11.5 10.2798 11.7798 10 12.125 10C12.4702 10 12.75 10.2798 12.75 10.625V16.875C12.75 17.2202 12.4702 17.5 12.125 17.5C11.7798 17.5 11.5 17.2202 11.5 16.875V10.625ZM8.375 10.625C8.375 10.2798 8.65484 10 9 10C9.34516 10 9.625 10.2798 9.625 10.625V16.875C9.625 17.2202 9.34516 17.5 9 17.5C8.65484 17.5 8.375 17.2202 8.375 16.875V10.625ZM5.25 10.625C5.25 10.2798 5.52984 10 5.875 10C6.22016 10 6.5 10.2798 6.5 10.625V16.875C6.5 17.2202 6.22016 17.5 5.875 17.5C5.52984 17.5 5.25 17.2202 5.25 16.875V10.625Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.17e02995.svg";
export { ForwardRef as ReactComponent };